/* 3.67 — SWATCH-FIRST QUICK ADD (option A of the multi-variant mockups).

   THE PROBLEM IT SOLVES. 41 of the 44 multi-variant cards on the bags
   collection already show their colours as swatches. Making a shopper open a
   popup to pick one of ten colours they are looking at asks the same question
   twice. This lets a swatch SELECT instead of navigate, after which the
   quick-add icon adds that exact colour in one tap — no overlay, no product
   page fetch.

   SCOPE — it only engages when all of these hold, and silently does nothing
   otherwise, falling back to the existing popup:
     · the swatch is a plain variant link (href carries ?variant=NNN)
     · it is a combined-listing sibling (data-sibling-url) that can be resolved
       to one variant — see COMBINED LISTINGS below
     · the card has a quick-add button
   Nothing is required of card-product.liquid: the variant id comes from the
   href Liquid already writes, and the colour name from the title attribute.
   That is deliberate — it keeps this feature to two new asset files.

   THE CARD PHOTO FOLLOWS THE SELECTION. This was very nearly left out, on the
   theory that rewriting the first slide of a cvc-strip would fight
   card-variant-carousel.js for the same node. Two things settled it the other
   way. First, card-swatch-hover.js has been doing exactly this swap, on exactly
   this markup, for desktop hover since 3.56 — the path is proven, not
   speculative. Second, seeing it without the swap on the preview made the case
   on its own: the Mini Kelly card sat there showing a rose-coloured bag with
   "Green" written underneath it. Name and price alone are accurate but they
   read as a mistake. 92% of the plain-variant swatches on the bags collection
   carry a data-variant-image, so this fires almost always; the 8% that do not
   simply keep the card photo, which is the honest fallback.

   WHY THE PRICE *IS* UPDATED — THIS ONE IS NOT COSMETIC. Colours can differ in
   price on the same product (Mini Kelly: Dusty Rose £129, Black £139). Arming
   the button against a variant while the card still showed the first colour's
   price would show one number and charge another. The price must follow the
   selection.

   COMBINED LISTINGS — ADDED IN 3.68, AFTER A BUG REPORT. 3.67 deliberately
   skipped sibling swatches, on the grounds that a sibling is a different
   PRODUCT and the card carries no variant id for it. Correct, and wrong: the
   shopper does not know what a combined listing is. They saw a colour swatch
   select on a bag card and the identical-looking swatch throw them onto another
   page on a sheepskin card, and reported it as broken. They were right.
   The variant id is obtainable — card-swatch-hover.js already fetches the
   sibling's .js for its photo and price, so the same JSON yields the id.

   3.69 WIDENED THIS, BECAUSE THE 3.68 GUARD BROKE BAGS. 3.68 resolved a sibling
   only when it had exactly ONE available variant. That is the SHEEPSKIN shape —
   one product per size-and-colour — and it tested clean there. BAGS ARE BUILT
   THE OPPOSITE WAY: Ginevra is split by MATERIAL into four products, each
   holding all its own colours as real variants. On a combined listing Shopify
   renders the UNION of every sibling's colours into the picker (this is the
   3.65 finding), so a Ginevra Leather card shows its own twelve colours PLUS
   colours belonging to the Raffia, Suede and Medium products. Those siblings
   have five or six available variants, so the one-variant guard rejected them
   and they fell back to navigation — leaving ONE swatch row where some colours
   select in place and others jump to another page, with nothing to tell them
   apart. Same complaint as 3.68, one layer down, caused by the guard written to
   fix it.
   RESOLUTION ORDER NOW:
     1. match the tapped colour NAME against the sibling's available variants;
        exactly one match wins. This is what makes multi-variant siblings work.
     2. failing that, a sibling with exactly one available variant (the old
        rule, kept for any child whose option values do not carry the colour).
     3. otherwise genuinely ambiguous — navigate, as before.
   The fetch is cached on the swatch element, so a second tap costs nothing.

   THE CARD ALSO RE-TITLES ITSELF ON A SIBLING SELECTION. Families like Giannina
   and Silvia put the colour in the product TITLE ("… by Clemés, Champagne"), so
   selecting Tan on the Champagne card previously left the heading contradicting
   the swatch, the photo and the price. Heading text and link now follow the
   sibling too, and restore on deselect, so the whole card describes one product.

   PLAYS NICE WITH card-swatch-hover.js, which does the same swap transiently on
   desktop hover and stashes the pre-hover state in data-orig-html /
   data-orig-src. On selection we REWRITE those stashes to the selected state,
   so a later hover-then-mouseout restores to the chosen colour and not to the
   card's original one. Remove that and hovering a second swatch silently
   reverts the visible price while the button stays armed to the old variant —
   which is the mismatch this whole comment is about. */
(function () {
  if (window.__swatchSelectInit) return;
  window.__swatchSelectInit = true;

  var SW = '.card-swatches__swatch';

  function announce(msg) {
    var el = document.getElementById('CardSwatchLive');
    if (!el) {
      el = document.createElement('div');
      el.id = 'CardSwatchLive';
      el.className = 'visually-hidden';
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
  }

  function variantIdOf(sw) {
    if (sw.hasAttribute('data-sibling-url')) return null;
    var m = (sw.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function priceEl(card) {
    return card.querySelector('.card-information .price');
  }

  function qaBtn(card) {
    return card.querySelector('.quick-add__submit');
  }

  function mediaEl(card) {
    return card.querySelector('.card__media .media');
  }

  /* Write a variant's price into the card, then re-stash it as the "original"
     so card-swatch-hover.js restores to here rather than to the card default. */
  function setPrice(card, priceText, compareText) {
    var el = priceEl(card);
    if (!el || !priceText) return;
    var saleCompare = el.querySelector('.price__sale .price-item--regular');
    var saleItem = el.querySelector('.price__sale .price-item--sale');
    var regItem = el.querySelector('.price__regular .price-item--regular');
    if (compareText && saleCompare && saleItem) {
      saleCompare.textContent = compareText;
      saleItem.textContent = priceText;
      el.classList.add('price--on-sale');
    } else if (regItem) {
      regItem.textContent = priceText;
      el.classList.remove('price--on-sale');
    }
    el.setAttribute('data-orig-html', el.innerHTML);
    el.setAttribute('data-orig-class', el.className);
  }

  function restorePrice(card) {
    var el = priceEl(card);
    if (!el || !el.hasAttribute('data-card-default-html')) return;
    el.innerHTML = el.getAttribute('data-card-default-html');
    el.className = el.getAttribute('data-card-default-class');
    el.removeAttribute('data-orig-html');
    el.removeAttribute('data-orig-class');
  }

  function rememberDefault(card) {
    var el = priceEl(card);
    if (el && !el.hasAttribute('data-card-default-html')) {
      el.setAttribute('data-card-default-html', el.innerHTML);
      el.setAttribute('data-card-default-class', el.className);
    }
    var media = mediaEl(card);
    var img = media && media.querySelector('img');
    if (img && !img.hasAttribute('data-card-default-src')) {
      img.setAttribute('data-card-default-src', img.getAttribute('src') || '');
      img.setAttribute('data-card-default-srcset', img.getAttribute('srcset') || '');
    }
    headingLinks(card).forEach(function (a) {
      if (!a.hasAttribute('data-card-default-title')) {
        a.setAttribute('data-card-default-title', a.textContent.trim());
        a.setAttribute('data-card-default-href', a.getAttribute('href') || '');
      }
    });
  }

  /* Both of them: card-product.liquid renders a heading inside card__inner (for
     the no-media layout) and another in card__content. Whichever is visible,
     keep them saying the same thing. */
  function headingLinks(card) {
    return Array.prototype.slice.call(card.querySelectorAll('.card__heading a'));
  }

  function setHeading(card, title, url) {
    if (!title) return;
    headingLinks(card).forEach(function (a) {
      a.textContent = title;
      if (url) a.setAttribute('href', url);
    });
  }

  function restoreHeading(card) {
    headingLinks(card).forEach(function (a) {
      if (!a.hasAttribute('data-card-default-title')) return;
      a.textContent = a.getAttribute('data-card-default-title');
      var href = a.getAttribute('data-card-default-href');
      if (href) a.setAttribute('href', href);
    });
  }

  /* Swap the strip's first slide to the variant's photo. srcset has to go: it
     would otherwise out-vote the src we just set. As with the price, the
     hover script's restore target is rewritten to the selection, so a hover
     elsewhere and back does not quietly undo this. */
  function setImage(card, url) {
    if (!url) return;
    var media = mediaEl(card);
    var img = media && media.querySelector('img');
    if (!img) return;
    media.classList.add('swatch-selected');
    img.removeAttribute('srcset');
    img.setAttribute('src', url);
    img.setAttribute('data-orig-src', url);
    img.setAttribute('data-orig-srcset', '');
  }

  function restoreImage(card) {
    var media = mediaEl(card);
    var img = media && media.querySelector('img');
    if (!img || !img.hasAttribute('data-card-default-src')) return;
    var src = img.getAttribute('data-card-default-src');
    var ss = img.getAttribute('data-card-default-srcset');
    img.setAttribute('src', src);
    if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
    img.setAttribute('data-orig-src', src);
    img.setAttribute('data-orig-srcset', ss || '');
    if (media) media.classList.remove('swatch-selected');
  }

  function nameLine(card, text) {
    var line = card.querySelector('.card-swatch-selected');
    if (!text) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('div');
      line.className = 'card-swatch-selected';
      var row = card.querySelector('.card-price-row');
      if (!row || !row.parentNode) return;
      row.parentNode.insertBefore(line, row.nextSibling);
    }
    line.textContent = text;
  }

  /* 3.86 — KEEP THE CARD'S ADD FORM IN STEP WITH THE SWATCH.
     Multi-variant cards now render the same <product-form> a single-variant card
     uses (see card-product.liquid), and its hidden id is the first available
     variant. The capture-phase handler at the foot of this file normally
     intercepts the click and adds the ARMED variant instead, so syncing the form
     is belt and braces — but if that interception ever fails to run, an unsynced
     form would add the first colour while the card is showing a different one.
     That is the worst failure available here: silent, and wrong in a way the
     shopper only discovers after paying. Cheaper to keep the two in step. */
  function qaWrap(card) {
    return card.querySelector('.quick-add');
  }
  function variantInput(card) {
    return card.querySelector('.quick-add [name="id"]');
  }
  function setFormVariant(card, id) {
    var input = variantInput(card);
    if (!input) return;
    if (!input.hasAttribute('data-default-variant')) {
      input.setAttribute('data-default-variant', input.value);
    }
    input.value = id;
  }
  function restoreFormVariant(card) {
    var input = variantInput(card);
    if (!input) return;
    var d = input.getAttribute('data-default-variant');
    if (d) input.value = d;
  }

  function disarm(card) {
    card.querySelectorAll(SW).forEach(function (s) { s.removeAttribute('aria-current'); });
    var btn = qaBtn(card);
    if (btn) {
      btn.removeAttribute('data-armed-variant');
      btn.removeAttribute('aria-label');
      btn.classList.remove('quick-add__submit--armed');
    }
    var wrapOff = qaWrap(card);
    if (wrapOff) wrapOff.classList.remove('quick-add--armed');
    restoreFormVariant(card);
    nameLine(card, '');
    restorePrice(card);
    restoreImage(card);
    restoreHeading(card);
  }

  /* The shared half: everything that happens once a variant id is known,
     whichever route found it. */
  function applySelection(card, sw, id, sibling) {
    var btn = qaBtn(card);
    if (!id || !btn) return false;

    rememberDefault(card);

    card.querySelectorAll(SW).forEach(function (s) { s.removeAttribute('aria-current'); });
    sw.setAttribute('aria-current', 'true');

    var name = sw.getAttribute('title') || '';
    nameLine(card, name);
    setPrice(card, sw.getAttribute('data-variant-price'), sw.getAttribute('data-variant-compare'));
    setImage(card, sw.getAttribute('data-variant-image'));
    if (sibling) setHeading(card, sibling.title, sibling.url);

    btn.setAttribute('data-armed-variant', id);
    setFormVariant(card, id);
    var wrapOn = qaWrap(card);
    if (wrapOn) wrapOn.classList.add('quick-add--armed');
    btn.classList.add('quick-add__submit--armed');
    if (name) btn.setAttribute('aria-label', 'Add ' + name + ' to basket');
    announce(name + ' selected');
    return true;
  }

  function select(card, sw) {
    return applySelection(card, sw, variantIdOf(sw));
  }

  /* Resolve a combined-listing sibling to a single variant, filling in the
     photo and price attributes (the hover prefetch never runs on touch devices,
     where most of this store's adds happen). Resolves to null when the sibling
     cannot be pinned to one variant. */
  function resolveSibling(sw, url) {
    var cached = sw.getAttribute('data-sibling-variant');
    if (cached) {
      return Promise.resolve(
        cached === 'none'
          ? null
          : { id: cached, title: sw.getAttribute('data-sibling-title') || '', url: url }
      );
    }

    var wanted = (sw.getAttribute('title') || '').trim().toLowerCase();

    return fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        var v = null;

        /* 1. Match the tapped colour by name. A variant's `options` array holds
           its option VALUES, so a Ginevra Suede variant in Cognac contains
           "Cognac" whatever the option is called - which sidesteps the
           Colour/Color spelling split across this catalogue. Exactly one match
           required; two variants sharing a colour name (a colour+size product)
           is ambiguous and must not be guessed at. */
        if (wanted) {
          var matches = avail.filter(function (x) {
            return (x.options || []).some(function (o) {
              return String(o).trim().toLowerCase() === wanted;
            });
          });
          if (matches.length === 1) v = matches[0];
        }

        /* 2. Single-variant sibling - the sheepskin shape. Kept as a fallback
           for any child whose option values do not carry the colour name. */
        if (!v && avail.length === 1) v = avail[0];

        if (!v) {
          sw.setAttribute('data-sibling-variant', 'none');
          return null;
        }

        sw.setAttribute('data-sibling-variant', String(v.id));
        sw.setAttribute('data-sibling-title', p.title || '');

        /* Overwrite rather than fill-if-empty: card-swatch-hover.js may have
           already written the sibling's PRODUCT-level price here, and we now
           know the specific variant, which on a multi-colour sibling can differ.
           The armed button and the visible price must describe the same thing. */
        if (typeof v.price === 'number') {
          sw.setAttribute('data-variant-price', fmtMoney(v.price));
          if (v.compare_at_price && v.compare_at_price > v.price) {
            sw.setAttribute('data-variant-compare', fmtMoney(v.compare_at_price));
          } else {
            sw.removeAttribute('data-variant-compare');
          }
        }
        var im = (v.featured_image && v.featured_image.src) || p.featured_image;
        if (im) sw.setAttribute('data-variant-image', im.split('?')[0] + '?width=533');

        return { id: String(v.id), title: p.title || '', url: url };
      })
      .catch(function () { return null; });
  }

  /* Money formatting, matching card-swatch-hover.js: whole amounts show no
     decimals here (£199, not £199.00), same as the Liquid money filter. */
  function fmtMoney(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (err) {
      return '£' + (whole ? String(cents / 100) : (cents / 100).toFixed(2));
    }
  }

  /* Swatch clicks. Capture phase so we settle this before anything else, but
     modifier and middle clicks are left alone — someone deliberately opening a
     variant in a new tab should still get one. No-JS visitors keep the link
     entirely, which is why these stayed <a href> rather than becoming buttons. */
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!e.target.closest) return;
    var sw = e.target.closest(SW);
    if (!sw) return;
    var card = sw.closest('.card-wrapper');
    if (!card || !qaBtn(card)) return; // no quick add on this card: navigate as before

    var sibUrl = sw.getAttribute('data-sibling-url');
    if (!sibUrl && !variantIdOf(sw)) return; // neither kind of swatch we handle

    e.preventDefault();
    e.stopPropagation();

    if (sw.getAttribute('aria-current') === 'true') {
      disarm(card);
      announce('Selection cleared');
      return;
    }

    if (!sibUrl) {
      select(card, sw);
      return;
    }

    /* Combined-listing sibling: the id needs a round trip. Mark the card busy
       so a slow network does not look like a dead tap, and fall back to the
       old navigation if the sibling turns out to be ambiguous or the fetch
       fails — never leave the shopper with nothing having happened. */
    card.setAttribute('data-swatch-busy', '1');
    resolveSibling(sw, sibUrl)
      .then(function (res) {
        card.removeAttribute('data-swatch-busy');
        if (res) applySelection(card, sw, res.id, res);
        else window.location.href = sibUrl;
      })
      .catch(function () {
        card.removeAttribute('data-swatch-busy');
        window.location.href = sibUrl;
      });
  }, true);

  /* Armed quick-add button. Capture phase again, because modal-opener binds its
     own click listener on this same button — letting that run would open the
     popup we are here to avoid. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.quick-add__submit');
    if (!btn) return;
    var id = btn.getAttribute('data-armed-variant');
    if (!id) return; // not armed: today's behaviour, popup and all

    e.preventDefault();
    e.stopPropagation();
    if (btn.hasAttribute('data-adding')) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.addVariant !== 'function') return;

    btn.setAttribute('data-adding', '1');
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    Promise.resolve(drawer.addVariant(Number(id)))
      .then(function () {
        if (typeof drawer.open === 'function') drawer.open();
        announce('Added to basket');
      })
      .catch(function () {})
      .finally(function () {
        btn.removeAttribute('data-adding');
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
})();
